import { useChatClass } from "../../theme";
import { Message } from "../Message";
import { Timestamp } from "../Timestamp";
import { useAutoScroll } from "../../hooks";
import { Container, Debug, Row } from "./styled";

export interface DebugActionProps {
  label: string;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
}

export interface DebugResponseProps {
  message: string;
  reason?: string;
  action?: DebugActionProps;
}

export interface UserResponseProps {
  /** The message text to display */
  message: string;
  /** A unix timestamp indicating when this response was sent. */
  timestamp: number;
  /** Optional preformatted timestamp text. */
  timestampLabel?: string;
  /** If provided, adds a caption and optional "debug" message with an action  */
  debug?: DebugResponseProps;
}

interface UserResponseComponent extends React.FC<UserResponseProps> {
  Container: typeof Container;
  Debug: typeof Debug;
  Row: typeof Row;
}

/** A user-sent text response. */
const UserResponse: UserResponseComponent = ({
  message,
  timestamp,
  timestampLabel,
  debug,
}: UserResponseProps) => {
  useAutoScroll();
  const chatClass = useChatClass();

  return (
    <Container className={chatClass("user-message")} aria-label="User message">
      <Row>
        <Timestamp value={timestamp} label={timestampLabel} />
        <Message direction="user">{message}</Message>
      </Row>
      {debug && <Debug role="note">{debug.message}</Debug>}
    </Container>
  );
};

UserResponse.Container = Container;
UserResponse.Debug = Debug;
UserResponse.Row = Row;

export { UserResponse };
